import React, { Suspense, useEffect } from 'react';
import { Switch, useHistory, useLocation, Route } from 'react-router-dom';
import Loader from '@Components/Loader';
import ErrorBoundary from '@Components/ErrorBoundary';
// import AuthenProvider from '@Components/AuthenWrapper';
import { useSelector } from 'react-redux';
import PageNotFound from '../views/PageNotFound';
import { privateConstant } from './private/contant';
import { resolveDefaultPrivatePath } from './private/defaultRoute';
import { publicConstant } from './public/contant';
import PrivateRoutes from './private/routes';
import PublicRoutes from './public/routes';

function Routes() {
  function renderPrivateRoutes() {
    let xhtml = null;
    const parentRouter = [];
    const childRouter = [];
    const routes = privateConstant;
    routes.map((router) => {
      if (router.child && router.child.length > 0) {
        const { accessName } = router;
        router.child.map((child) => {
          const item = { ...child, accessName };
          const { accessName: accessChild } = child;
          if (accessName) {
            item.accessChild = accessChild;
          }
          childRouter.push(item);
        });
      } else {
        parentRouter.push(router);
      }
      return '';
    });
    const routerNeedRender = [...parentRouter, ...childRouter];

    xhtml = routerNeedRender.map((route) => (
      <PrivateRoutes
        component={route.component}
        exact={route.exact}
        key={route.id}
        path={route.path}
        accessName={route.accessName}
        accessChild={route.accessChild}
      />
    ));
    return xhtml;
  }

  function renderPublicRoutes() {
    let xhtml = null;
    xhtml = publicConstant.map((route) => (
      <PublicRoutes
        component={route.component}
        exact={route.exact}
        key={route.id}
        path={route.path}
      />
    ));
    return xhtml;
  }

  const location = useLocation();
  const { pathname, state } = location;
  const token = localStorage.getItem(process.env.TOKEN);
  const history = useHistory();
  const accessPermisions = useSelector((state) => state.user.accessPermisions);
  const userInfo = useSelector((state) => state.user.info);
  const checkIsPrivate = privateConstant.find((item) => item.path === pathname);

  useEffect(() => {
    if (!token && pathname === '/') {
      history.replace('/login');
      return;
    }

    if (!token && checkIsPrivate) {
      history.replace('/login');
      return;
    }

    if (token && pathname === '/') {
      const defaultPrivatePath = resolveDefaultPrivatePath(accessPermisions, userInfo);

      if (defaultPrivatePath) {
        history.replace(defaultPrivatePath);
        return;
      }

      history.replace({
        pathname: '/dashboard',
        state: { ...state, login: 'Login' },
      });
    }
  }, [token, pathname, checkIsPrivate, accessPermisions, userInfo, state, history]);

  return (
    // <AuthenProvider>
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Switch>
          {renderPrivateRoutes()}
          {renderPublicRoutes()}
          <Route component={PageNotFound} path="*" />
        </Switch>
      </Suspense>
    </ErrorBoundary>
    // </AuthenProvider>
  );
}

export default Routes;
